<div class="container">
  <app-publisher-avatar class="ion-float-left" [publisher]="item.createdBy"></app-publisher-avatar>
  <p>
    <span>Sent by {{ item.createdBy?.displayName || 'Unknown' }}</span>

    @if (showPublisherLink) {
      <span> about </span>
    }

    @if (showPublisherLink && item.student) {
      <a class="channel" (click)="showPaymentRequests($event)">
        {{ item.student?.forename }}
      </a>
    }
  </p>
</div>
